import { useRef, useEffect, RefObject } from 'react';

const useClickOutside = (handler: () => void): RefObject<HTMLDivElement | null> => {
    const domNode = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (domNode.current && !domNode.current.contains(event.target as Node)) {
                handler();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handler]);

    return domNode;
};

export default useClickOutside;
